/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 个人中心首页获取用户信息-数据埋点
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.MemberInfoForIoDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/infoForIo`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
